module.exports = __webpack_public_path__ + "img/chan.29b6de27.jpg";